// extracted by mini-css-extract-plugin
export default {"content-root":"uiqQ1","contentRoot":"uiqQ1","title":"_1-bFf","message":"_1nZ12","image":"-VRCu"};